import api from '../_api';

const retrieveAvCountries = (context) => {

    api.fetchAvCountries(context, axios)
        .then(
            (response) => {
                context.commit('updateAvCountries', response.data)
            }
        )
        .catch(
            (error) => {
                console.error(error);
            }
        )
}

export default {
    retrieveAvCountries
}
